import { ThunkAction } from 'redux-thunk'
import { RouterAction } from 'connected-react-router'
import { AppState } from './reducers'

export type LocaleTypes = 'en' | 'nl' | 'de'

export type Location = {
	latitude: string
	longitude: string
	name: string
}

export type Stock = {
	name: string
	stock: number
}

export interface Subscription {
	firstname: string
	lastname: string
	email: string
}

export type ThunkResult<R> = ThunkAction<R, AppState, undefined, ActionTypes>

export const CALL_ASSISTANT = 'CALL_ASSISTANT'
export const CALL_ASSISTANT_FULFILLED = 'CALL_ASSISTANT_FULFILLED'
export const CALL_ASSISTANT_REJECTED = 'CALL_ASSISTANT_REJECTED'

export const SET_LOCALE = 'SET_LOCALE'
export const START_SCANNING = 'START_SCANNING'
export const STOP_SCANNING = 'STOP_SCANNING'
export const DETECT_BARCODE = 'DETECT_BARCODE'
export const SEARCH_BARCODE = 'SEARCH_BARCODE'
export const SEARCH_BARCODE_FULFILLED = 'SEARCH_BARCODE_FULFILLED'
export const RESET_ASSISTANT = 'RESET_ASSISTANT'

export const FETCH_PRODUCT = 'FETCH_PRODUCT'
export const FETCH_PRODUCT_FULFILLED = 'FETCH_PRODUCT_FULFILLED'

export const SUBSCRIBE = 'SUBSCRIBE'
export const SUBSCRIBE_FULFILLED = 'SUBSCRIBE_FULFILLED'
export const SUBSCRIBE_REJECTED = 'SUBSCRIBE_REJECTED'

interface ResetAssistantAction {
	type: typeof RESET_ASSISTANT
}

interface CallAssistantAction {
	type: typeof CALL_ASSISTANT
}

interface CallAssistantFulfilledAction {
	type: typeof CALL_ASSISTANT_FULFILLED
}

interface CallAssistantRejectedAction {
	type: typeof CALL_ASSISTANT_REJECTED
}

interface SetLocaleAction {
	type: typeof SET_LOCALE
	payload: {
		locale: LocaleTypes
	}
}

interface StartScanningAction {
	type: typeof START_SCANNING
}

interface StopScanningAction {
	type: typeof STOP_SCANNING
}

interface DetectBarcodeAction {
	type: typeof DETECT_BARCODE
	payload: {
		barcode: string
	}
}

interface SearchBarcodeAction {
	type: typeof SEARCH_BARCODE
	payload: {
		barcode: string
	}
}

interface SearchBarcodeFulfilledAction {
	type: typeof SEARCH_BARCODE_FULFILLED
	payload: {
		product: Record<string, string> | null
		option: Record<string, string> | null
		price: number | null
		location: Location[]
		stocks: Stock[]
		bestBefore: number | null
	}
}

interface FetchProductAction {
	type: typeof FETCH_PRODUCT
	payload: {
		id: string
	}
}

interface FetchProductFulfilledAction {
	type: typeof FETCH_PRODUCT_FULFILLED
	payload: {
		product: Record<string, string> | null
	}
}

interface SubscribeAction {
	type: typeof SUBSCRIBE
	payload: {
		subscription: Subscription
	}
}

interface SubscribeFulfilledAction {
	type: typeof SUBSCRIBE_FULFILLED
}

interface SubscribeRejectedAction {
	type: typeof SUBSCRIBE_REJECTED
}

export type ActionTypes =
	| CallAssistantAction
	| CallAssistantFulfilledAction
	| CallAssistantRejectedAction
	| SetLocaleAction
	| StartScanningAction
	| StopScanningAction
	| DetectBarcodeAction
	| SearchBarcodeAction
	| SearchBarcodeFulfilledAction
	| ResetAssistantAction
	| RouterAction
	| FetchProductAction
	| FetchProductFulfilledAction
	| SubscribeAction
	| SubscribeFulfilledAction
	| SubscribeRejectedAction

